import actions from './actions';

const initState = {
  visibility: false,
  info: {}
};

export default function transactionReducer(state = initState, action) {
  switch (action.type) {
    case actions.OPEN_TRANSACTION:
      return {visibility: true, info: action.payload};

    case actions.CLOSE_TRANSACTION:
      return { visibility: false, info: {}};

    default:
      return state;
  }
}
